<template>
  <canvas :id="chartID"></canvas>
</template>
<script>
import {
  Chart,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  // Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
} from "chart.js";
export default {
  props: ["data", "options", "title"],
  data() {
    return {
      chart: {},
      chartID: `chart${Math.random()}`
    };
  },
  mounted() {
    // this.renderChart();
    Chart.register(
      ArcElement,
      LineElement,
      BarElement,
      PointElement,
      BarController,
      BubbleController,
      DoughnutController,
      LineController,
      PieController,
      PolarAreaController,
      RadarController,
      ScatterController,
      CategoryScale,
      LinearScale,
      LogarithmicScale,
      RadialLinearScale,
      TimeScale,
      TimeSeriesScale,
      Filler,
      Legend,
      Title,
      Tooltip
    );
  },
  watch: {
    data() {
      this.renderChart();
    },
  },
  computed: {
    dataSet() {
      let colors = [];
      this.data.labels.forEach((element) => {
        colors.push(this.getRandomColor());
      });
      return {
        labels: this.data.labels,
        datasets: [
          {
            label: this.title,
            data: this.data.values,
            // borderColor: Utils.CHART_COLORS.red,
            backgroundColor: colors,
          },
        ],
      };
    },
  },
  methods: {
    renderChart() {
      console.log("dd", this.data);
      const ctx = document.getElementById(this.chartID);
      this.chart = new Chart(ctx, {
        type: "bar",
        data: this.dataSet,
        options: {
          responsive: true,
          scales: {
            y: {
              ticks: {
                stepSize: 1,
                font: {
                  family: "iranyekan",
                  size: 14,
                },
              },
            },
            x: {
              grid: {
                display: false,
              },
              ticks: {
                font: {
                  family: "iranyekan",
                  size: 14,
                },
                autoSkip: false,
                maxRotation: 90,
                minRotation: 90,
              },
            },
          },
          tooltips: {
              titleFontFamily: "iranyekan",
          },
          plugins: {
            legend: {
              position: "top",
              labels: {
                // This more specific font property overrides the global property
                font: {
                  size: 14,
                  family: "iranyekan",
                },
              },
            },
            title: {
              display: true,
              text: this.title,
              font: {
                size: 14,
                family: "iranyekan",
              },
            },
          },
        },
      });
    },
    getRandomColor() {
      var letters = "0123456789ABCDEF".split("");
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },
};
</script>
